import {BaseDalService} from "@hec/core";
import {AppConfiguration, ApplicationService} from "@hec/models";
import axios, {AxiosInstance} from "axios";
import {OrderDto} from "@hec/api-dtos";

export class PostOrderService extends BaseDalService implements ApplicationService {

  private client: AxiosInstance;
  public static override serviceName = Symbol('GetOrderService');

  constructor() {
    super();
    this.client = axios.create({});
  }

  override configure(configuration: AppConfiguration) {
    this.client = axios.create({
      baseURL: `${configuration.baseUrl}/api`,
    });

    this.useDateTimeConverters(this.client);
    this.useEnumConverters(this.client);
  }


  getName(): symbol {
    return PostOrderService.serviceName;
  }

  static override getName(): symbol {
    return PostOrderService.serviceName;
  }

  async cloneOrder(configurationTemplateId: string): Promise<OrderDto> {
    this.client.interceptors.request.use((config) => {
      config.headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      };
      return config;
    });

    const response = await this.client.post('/orders/', {configurationTemplateId: configurationTemplateId});


    if (response.status === 200) {
      return response.data as OrderDto;
    }

    throw new Error(`GetOrderService: getOrder resulted in ${response.status}: ${response.statusText}`);
  }
}
